import React from "react";
import { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  Link,
  Typography,
  CircularProgress,
  Alert,
  InputAdornment,
  IconButton,
  Snackbar,
  useTheme,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { connect } from "react-redux";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { withRouter } from "../../hooks/withRouter";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    // display: "flex",
    "& > * + *": {
      // marginLeft: theme.spacing(2),
    },
    backgroundRepeat: "no-repeat",
  },
  paper: {
    // marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  circularProgress: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#121212",
  },
  container: {
    marginLeft: "0px",
    width: "100vw",
    height: "100vh",
    position: "relative",
    display: "flex",
    fontFamily: "roboto",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  avatar: {
    margin: theme.spacing(2),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  loginFormCard: {
    padding: theme.spacing(4),
    marginTop: "8%",
    margin: "auto",
    width: "26%",
    alignSelf: "end",
    background: theme.palette.secondary.main,
    borderRadius: theme.spacing(2),
    boxShadow: "0 0 1px",
    fontSize: "10",
    [theme.breakpoints.down("xl")]: {
      display: "flex",
      alignSelf: "center",
      justifyContent: "center",
      flexDirection: "column",
      width: "330px",
      // height: "500px",
      padding: theme.spacing(4),
      marginTop: "auto",
      fontSize: "15",
      marginBottom: "auto",
    },
    [theme.breakpoints.up("xl")]: {
      // background: "#313131",
      display: "flex",
      alignSelf: "center",
      justifyContent: "center",
      flexDirection: "column",
      width: "350px",
      // height: "600px",
      padding: theme.spacing(3, 6),
      marginTop: "auto",
      fontSize: "15",
      marginBottom: "auto",
    },
    [theme.breakpoints.down("lg")]: {
      // background: "#313131",
      display: "flex",
      alignSelf: "center",
      justifyContent: "center",
      flexDirection: "column",
      width: "330px",
      // height: "500px",
      padding: theme.spacing(4),
      marginTop: "auto",
      fontSize: "15",
      marginBottom: "auto",
    },
    [theme.breakpoints.down("md")]: {
      // background: "#1E1E1E",
      display: "flex",
      alignSelf: "center",
      justifyContent: "center",
      flexDirection: "column",
      margin: "auto",
      width: "320px",
      // height: "520px",
      padding: theme.spacing(4),
      fontSize: "10",
      // marginBottom: "auto",
    },
    [theme.breakpoints.down("sm")]: {
      // background: "#1E1E1E",
      margin: "0px 10px",
      height: "470px",
    },
  },
  inputFields: {
    borderRadius: "1.5rem",
  },
  submit: {
    margin: theme.spacing(3.4, 0, 0, 0),
    padding: theme.spacing(1, 0),
    textTransform: "none",
    borderRadius: "5px",
    background: "#006bce",
    "&:hover": {
      background: "#004a8f",
    },
  },
  formControl: {
    width: "100%",
    margin: theme.spacing(1.4, 0),
  },
  inputLabel: {
    margin: theme.spacing(-0.75, 4, 0, 2),
    color: "grey",
    zIndex: 10,
  },
  text: {
    // marginTop: "5px",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  mainHeading: {
    [theme.breakpoints.down("md")]: {
      fontSize: "21px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "21px",
    },
  },
  links: {
    fontSize: "13",
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: "11.5px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "13.5px",
    },
  },
}));

const Login = (props) => {
  const [username, setUsername] = useState("");
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState();
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Automatically redirect to Accounts portal on mount
    const isLocalhost = window.location.hostname === "localhost";
    const authBaseUrl = isLocalhost
      ? "http://localhost:3000"
      : "https://accounts.vecros.com";

    // Use window.location.origin as redirect origin
    window.location.href = `${authBaseUrl}/auth/login?redirect=${encodeURIComponent(
      window.location.origin
    )}`;
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    props.onAuth(username, password);
    setOpen(true);
  };

  if (props.isAuthenticated) {
    navigate("/");
  }

  return (
    <Box>
      <Box
        className={classes.container}
        style={{
          // backgroundImage: `url(${drone})`,
          background: theme.palette.primary.main,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        {props.error && (
          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Box>
              <Alert onClose={handleClose} severity="error">
                {typeof props.error === "string" ? props.error : props.error.message || props.error.errorMessage || "An unknown error occurred"}
              </Alert>
            </Box>
          </Snackbar>
        )}
        {props.loading ? (
          <Box className={classes.circularProgress}>
            <CircularProgress
              size="40"
              sx={{ color: theme.palette.text.color }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              textAlign: "left",
            }}
          >
            <Box style={{ marginBottom: "20px" }}>
              <Typography
                align="center"
                style={{ fontSize: "45px", color: theme.palette.text.color }}
              >
                Welcome back , Login{" "}
              </Typography>
              <Typography
                align="center"
                style={{ color: "#a1a1a1", fontSize: "14px" }}
              >
                Enter your credentials to Login to VCS
              </Typography>
            </Box>
            <Box className={classes.loginFormCard}>
              <div className={classes.paper}>
                <form onSubmit={handleSubmit} className={classes.form}>
                  <label style={{ color: theme.palette.text.color }}>
                    Email *
                  </label>
                  <TextField
                    inputProps={{
                      style: {
                        padding: "12px",
                        letterSpacing: "0.4px",
                      },
                    }}
                    sx={{
                      background: "none !important",
                      fontSize: "10px",
                      color: theme.palette.text.color,
                      display: "flex",
                      alignItems: "center",

                      // Autofill Styles
                      "& input": {
                        "&:-webkit-autofill": {
                          "-webkit-text-fill-color": `${theme.palette.text.color} !important`,
                          "-webkit-box-shadow": `0 0 0 100px ${theme.palette.primary.main} inset !important`,
                          backgroundColor: "none !important",
                          // backgroundColor: 'none !important',
                          transition: "background-color 5000s ease-in-out 0s",
                        },
                        "&:hover:-webkit-autofill": {
                          "-webkit-text-fill-color": `${theme.palette.text.color} !important`,
                          "-webkit-box-shadow": `0 0 0 100px ${theme.palette.primary.main} inset !important`,
                          backgroundColor: "none !important",
                        },
                        "&:active:-webkit-autofill": {
                          "-webkit-text-fill-color": `${theme.palette.text.color} !important`,
                          "-webkit-box-shadow": `0 0 0 100px ${theme.palette.primary.main} inset !important`,
                          backgroundColor: "none !important",
                        },
                      },

                      "& label": {
                        color: theme.palette.text.color,
                        fontSize: "17px",
                      },
                      "& label.Mui-focused": {
                        color: theme.palette.text.color,
                      },
                      "& .MuiOutlinedInput-input": {
                        color: theme.palette.text.color,
                      },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "5px",
                        "& fieldset": {
                          borderColor: theme.palette.border.color,
                        },
                        "&:hover fieldset": {
                          borderColor: theme.palette.border.color,
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: theme.palette.border.color,
                          color: theme.palette.text.color,
                        },
                      },
                      "& .MuiInputBase-input::placeholder": {
                        fontSize: "12px",
                        letterSpacing: "0.4px",
                      },
                    }}
                    variant="outlined"
                    value={username}
                    onInput={(e) => setUsername(e.target.value)}
                    margin="dense"
                    required
                    fullWidth
                    placeholder="Enter your email"
                    id="username"
                    // label="Email"
                    name="username"
                    autoComplete="username"
                    autoFocus
                  />

                  <br />
                  <label style={{ color: theme.palette.text.color }}>
                    Password *
                  </label>
                  <TextField
                    inputProps={{
                      style: {
                        padding: "12px",
                        letterSpacing: "0.4px",
                        // "&.MuiOutlinedInput-notchedOutline": { fontSize: "28px" }
                      },
                    }}
                    sx={{
                      background: "none !important",
                      fontSize: "10px",
                      color: theme.palette.text.color,
                      display: "flex",
                      alignItems: "center",
                      "& label": {
                        color: theme.palette.text.color,
                        fontSize: "17px",
                      },
                      "& label.Mui-focused": {
                        color: theme.palette.text.color,
                      },
                      "& .MuiOutlinedInput-input": {
                        color: theme.palette.text.color,
                      },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "5px",
                        "& fieldset": {
                          borderColor: theme.palette.border.color,
                          // background: '#fff'
                        },
                        "&:hover fieldset": {
                          borderColor: theme.palette.border.color,
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: theme.palette.border.color,
                          backgroundColor: "transparent",
                          color: "#666",
                        },
                        "&:-webkit-autofill": {
                          backgroundColor: "none !important",
                          WebkitBoxShadow: "none !important",
                          WebkitTextFillColor: theme.palette.text.color,
                        },
                        "&:-internal-autofill-selected": {
                          backgroundColor: "none !important",
                          WebkitBoxShadow: "none !important",
                          WebkitTextFillColor: theme.palette.text.color,
                        },
                        "& .MuiInputBase-Input::placeholder": {
                          fontSize: "12px",
                          letterSpacing: "0.4px",
                        },
                        // borderRadius: "5px",
                      },
                    }}
                    variant="outlined"
                    margin="dense"
                    value={password}
                    onInput={(e) => setPassword(e.target.value)}
                    required
                    fullWidth
                    name="password"
                    placeholder="Enter your password"
                    // label="Password"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    autoComplete="current-password"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                              setShowPassword((prevState) => !prevState)
                            }
                            onMouseDown={() =>
                              setShowPassword((prevState) => !prevState)
                            }
                            edge="end"
                          >
                            {showPassword ? (
                              <VisibilityOff
                                sx={{
                                  fill: "#828282",
                                  height: "20px",
                                  width: "20px",
                                  "&:hover": {
                                    backgroundColor: "none !important",
                                  },
                                }}
                              />
                            ) : (
                              <Visibility
                                sx={{
                                  fill: "#828282",
                                  height: "20px",
                                  width: "20px",
                                  "&:hover": {
                                    backgroundColor: "none !important",
                                  },
                                }}
                              />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "16px",
                    }}
                  >
                    <Box
                      sx={{ display: "flex", color: theme.palette.text.color }}
                    >
                      <input type="checkbox" />
                      <Typography
                        style={{ fontSize: "14px", marginLeft: "5px" }}
                      >
                        Remember Password
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        style={{
                          color: theme.palette.text.color,
                          fontSize: "14px",
                        }}
                      >
                        <Link
                          style={{
                            color: "#006BCE",
                            fontSize: "14px",
                          }}
                          className={classes.links}
                        >
                          Forgot password?
                        </Link>
                      </Typography>
                    </Box>
                  </Box>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    // color="primary"
                    sx={{
                      backgroundColor: "#006bce",
                      color: "#fff",
                      marginTop: "28px",
                      textTransform: "none",
                    }}
                  >
                    Login
                  </Button>
                </form>
              </div>
              {/* <Box mt={2}>
              <Copyright />
            </Box> */}
            </Box>
            <Box style={{ position: "absolute", right: "60px", top: "60px" }}>
              <Link
                href="https://accounts.vecros.com"
                target="_blank"
                style={{ color: theme.palette.text.color, fontSize: "16px" }}
                className={classes.links}
              >
                Don't have an account? Submit a request for
                <Box
                  component="span"
                  style={{ color: "#006bce", textDecoration: "underline" }}
                >
                  {" "}
                  Sign Up{" "}
                </Box>
              </Link>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    token: state?.auth?.tk,
    isAuthenticated: state.auth.tk !== null && state.auth.tk !== undefined,
  };
};

// The page redirects to the accounts portal on mount (see useEffect), so this
// local form never actually submits — login is delegated to accounts.
const mapDispatchToProps = () => ({ onAuth: () => {} });

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
